import {
  IRequirementDefinitionResponse,
  RequirementStatus
} from "@wingspanhq/payments/dist/interfaces";
import { WSPanel } from "@wingspanhq/fe-component-library";
import React from "react";
import { DataViewGrid } from "../../../../shared/components/DataView";
import { useQueryRequirementsList } from "../../../../query/requirements/queries/useQueryRequirementsList";
import { useUserId } from "../../../../query/hooks/helpers";

export const DefaultActionDetails: React.FC<{
  requirementDefinition: IRequirementDefinitionResponse;
  engagementLength: number;
}> = ({ requirementDefinition, engagementLength }) => {
  const userId = useUserId();

  const queryPayeesRows = useQueryRequirementsList({
    filter: {
      payerId: userId,
      requirementDefinitionId: requirementDefinition.requirementDefinitionId
    },
    page: {
      size: 1000
    }
  });

  const allRequirements = queryPayeesRows.data || [];

  const completedRequirementsLength = allRequirements.filter(
    req => req.status === RequirementStatus.Complete
  ).length;

  return (
    <WSPanel shimmer={queryPayeesRows.isLoading}>
      <DataViewGrid
        gridColumns={2}
        data={[
          {
            label: "Requirement name",
            value: requirementDefinition.name
          },
          {
            label: "Engagement types with this requirement",
            value: engagementLength
          },
          {
            label: "Contractor requirements assigned",
            value: allRequirements.length
          },
          {
            label: "Contractor requirements completed",
            value: completedRequirementsLength
          }
        ]}
      />
    </WSPanel>
  );
};
